export default {
  'Add New Project': {
    en: 'Add New Project',
    ja: '新しいプロジェクトを追加',
    et: 'Lisa uusi projekti',
    lt: 'Pridėti naują projektą',
    ph: 'Add New Project',
    ch: 'Add New Project',
  },
  itemBadges: {
    en: 'Badges',
    ja: 'バッジ',
    et: 'Märki',
    lt: 'Ženkliukai',
    ph: 'Badges',
    ch: 'Badges',
  },
  Badge: {
    en: 'Badge',
    ja: 'バッジ',
    et: 'Märk',
    lt: 'Ženkliukas',
    ph: 'Badge',
    ch: 'Badge',
  },
  'Back to Profile': {
    en: 'Back to Profile',
    ja: 'Back to Profile',
    et: 'Back to Profile',
    lt: 'Back to Profile',
    ph: 'Back to Profile',
    ch: 'Back to Profile',
  },
  Challenges: {
    en: 'Challenges',
    ja: 'Challenges',
    et: 'Challenges',
    lt: 'Challenges',
    ph: 'Challenges',
    ch: 'Challenges',
  },
  Challenge: {
    en: 'Challenge',
    ja: 'Challenge',
    et: 'Challenge',
    lt: 'Challenge',
    ph: 'Challenge',
    ch: 'Challenge',
  },
  Project: {
    en: 'Project',
    ja: 'プロジェクト',
    et: 'Projekt',
    lt: 'Projektas',
    ph: 'Project',
    ch: 'Project',
  },
  Projects: {
    en: 'Projects',
    ja: 'プロジェクト',
    et: 'Projekti',
    lt: 'Projektai',
    ph: 'Projects',
    ch: 'Projects',
  },
  'View Profile': {
    en: 'View Profile',
    ja: 'プロフィールを見る',
    et: 'Vaata profiili',
    lt: 'Peržiūrėti paskyrą',
    ph: 'View Profile',
    ch: 'View Profile',
  },
  'About Me': {
    en: 'About Me',
    ja: '個人情報',
    et: 'Minust',
    lt: 'Apie mane',
    ph: 'About Me',
    ch: 'About Me',
  },
  Status: {
    en: 'Status',
    ja: 'Status',
    et: 'Status',
    lt: 'Status',
    ph: 'Status',
    ch: 'Status',
  },
  'Talk to me': {
    en: 'Talk to me',
    ja: 'チャット',
    et: 'Vestle minuga',
    lt: 'Kalbėk su manim!',
    ph: 'Talk to me',
    ch: 'Talk to me',
  },
  'Completed Projects': {
    en: 'Completed Projects',
    ja: '完成したプロジェクト',
    et: 'Valmistehtud projektid',
    lt: 'Baigti projektai',
    ph: 'Completed Projects',
    ch: 'Completed Projects',
  },
  'Work-In-Progress Projects': {
    en: 'Work-In-Progress Projects',
    ja: '製作中のプロジェクト',
    et: 'Pooleliolevad projektid',
    lt: 'Vykdomi projektai ',
    ph: 'Work-In-Progress Projects',
    ch: 'Work-In-Progress Projects',
  },
  Badges: {
    en: 'Badges',
    ja: 'バッジ',
    et: 'Märgid',
    lt: 'Ženkliukai',
    ph: 'Badges',
    ch: 'Badges',
  },
  'No projects have been created by this member yet': {
    en: 'No projects have been created by this member yet',
    ja: 'このメンバーはまだ作成したプロジェクトがありません',
    et: 'Kasutaja pole veel loonud ühtki projekti',
    lt: 'Šis narys kol kas nesukūrė projektų',
    ph: 'No projects have been created by this member yet',
    ch: 'No projects have been created by this member yet',
  },
  'No work-in-progress projects': {
    en: 'No work-in-progress projects',
    ja: '製作中のプロジェクトがありません',
    et: 'Pooleliolevaid projekte pole',
    lt: 'Nėra vykdomų projektų',
    ph: 'No work-in-progress projects',
    ch: 'No work-in-progress projects',
  },
  'Badges earned by': {
    en: 'Badges earned by',
    ja: 'バッジを獲得したメンバー',
    et: 'Saadud märgid',
    lt: 'Ženkliukai, kuriuos užsitarnavo',
    ph: 'Badges earned by',
    ch: 'Badges earned by',
  },
  'No badges have been earned by this member yet': {
    en: 'No badges have been earned by this member yet',
    ja: '獲得したバッジがありません',
    et: 'Kasutaja pole veel saanud ühtki märki',
    lt: 'Šis narys kol kas neužsitarnavo ženkliukų ',
    ph: 'No badges have been earned by this member yet',
    ch: 'No badges have been earned by this member yet',
  },
  Chat: {
    en: 'Chat',
    ja: 'チャット',
    et: 'Vestlus',
    lt: 'Pokalbiai',
    ph: 'Chat',
    ch: 'Chat',
  },
  Members: {
    en: 'Members',
    ja: 'メンバー',
    et: 'Liikmed',
    lt: 'Nariai',
    ph: 'Members',
    ch: 'Members',
  },
  memberDescRoot: {
    en: 'Connect with other VIVITA members in our community and find out what they are up to!',
    ja: '他のVIVITAメンバーとつながりましょう！',
    et: 'Suhtle teiste VIVITA kogukonna liikmetega ja saa teada, millega nemad tegelevad!',
    lt: 'Bendrauk su kitais VIVITA nariais ir matyk ką jie kuria!',
    ph: 'Connect with other VIVITA members in our community and find out what they are up to!',
    ch: 'Connect with other VIVITA members in our community and find out what they are up to!',
  },
  memberDescNonRoot: {
    en: 'Connect with other members in the VIVIBOOM community and find out what they are up to!',
    ja: 'VIVIBOOM コミュニティの他のメンバーとつながり、彼らが何をしているかを調べてください。',
    et: 'Võtke ühendust teiste VIVIBOOM kogukonna liikmetega ja uurige, millega nad tegelevad!',
    lt: 'Susisiekite su kitais VIVIBOOM bendruomenės nariais ir sužinokite, kuo jie užsiima!',
    ph: 'Connect with other members in the VIVIBOOM community and find out what they are up to!',
    ch: '与 VIVIBOOM 社区的其他成员联系，了解他们在做什么！',
  },
  'All Members': {
    en: 'All Members',
    ja: 'すべてのメンバー',
    et: 'Kõik liikmed',
    lt: 'Visi nariai',
    ph: 'All Members',
    ch: 'All Members',
  },
  'Discover All Creators': {
    en: 'Discover All Creators',
    ja: 'すべてのクリエーターを見る',
    et: 'Avasta kõik leiutajad',
    lt: 'Pamatyk visus narius',
    ph: 'Discover All Creators',
    ch: 'Discover All Creators',
  },
  'Search members': {
    en: 'Search members',
    ja: 'メンバー検索',
    et: 'Otsi liikmeid',
    lt: 'Ieškok narių',
    ph: 'Search members',
    ch: 'Search members',
  },
  Search: {
    en: 'Search',
    ja: '検索',
    et: 'Otsi',
    lt: 'Paieška',
    ph: 'Search',
    ch: 'Search',
  },
  'Please refresh to view members!': {
    en: 'Please refresh to view members!',
    ja: 'メンバーを見るためにブラウザをリロードしてください',
    et: 'Uuenda, et näha liikmeid!',
    lt: 'Atnaujink puslapį kad matytum kitus narius!',
    ph: 'Please refresh to view members!',
    ch: 'Please refresh to view members!',
  },
  'My Portfolio': {
    en: 'My Portfolio',
    ja: 'My Portfolio',
    et: 'My Portfolio',
    lt: 'My Portfolio',
    ph: 'My Portfolio',
    ch: 'My Portfolio',
  },
  'Edit Public Portfolio': {
    en: 'Edit Public Portfolio',
    ja: 'Edit Public Portfolio',
    et: 'Edit Public Portfolio',
    lt: 'Edit Public Portfolio',
    ph: 'Edit Public Portfolio',
    ch: 'Edit Public Portfolio',
  },
  'View Public Portfolio': {
    en: 'View Public Portfolio',
    ja: 'View Public Portfolio',
    et: 'View Public Portfolio',
    lt: 'View Public Portfolio',
    ph: 'View Public Portfolio',
    ch: 'View Public Portfolio',
  },
  'Create Public Portfolio': {
    en: 'Create Public Portfolio',
    ja: 'Create Public Portfolio',
    et: 'Create Public Portfolio',
    lt: 'Create Public Portfolio',
    ph: 'Create Public Portfolio',
    ch: 'Create Public Portfolio',
  },
  'Disable Public Portfolio': {
    en: 'Disable Public Portfolio',
    ja: 'Disable Public Portfolio',
    et: 'Disable Public Portfolio',
    lt: 'Disable Public Portfolio',
    ph: 'Disable Public Portfolio',
    ch: 'Disable Public Portfolio',
  },
  'You public portfolio has been disabled': {
    en: 'You public portfolio has been disabled',
    ja: 'You public portfolio has been disabled',
    et: 'You public portfolio has been disabled',
    lt: 'You public portfolio has been disabled',
    ph: 'You public portfolio has been disabled',
    ch: 'You public portfolio has been disabled',
  },
  VIVICOINWithCount_other: {
    en: '{{ count }} VIVICOINS',
    ja: '{{ count }} VIVICOINS',
    et: '{{ count }} VIVICOINS',
    lt: '{{ count }} VIVICOINS',
    ph: '{{ count }} VIVICOINS',
    ch: '{{ count }} VIVICOINS',
  },
  VIVICOINWithCount_one: {
    en: '{{ count }} VIVICOIN',
    ja: '{{ count }} VIVICOIN',
    et: '{{ count }} VIVICOIN',
    lt: '{{ count }} VIVICOIN',
    ph: '{{ count }} VIVICOIN',
    ch: '{{ count }} VIVICOIN',
  },
  'Please approach our crew to create your wallet!': {
    en: 'Please approach our crew to create your wallet!',
    ja: 'Please approach our crew to create your wallet!',
    et: 'Please approach our crew to create your wallet!',
    lt: 'Please approach our crew to create your wallet!',
    ph: 'Please approach our crew to create your wallet!',
    ch: 'Please approach our crew to create your wallet!',
  },
  '{{count}} more badges': {
    en: '{{count}} more badges',
    ja: '{{count}} more badges',
    et: '{{count}} more badges',
    lt: '{{count}} more badges',
    ph: '{{count}} more badges',
    ch: '{{count}} more badges',
  },
  '{{count}} more challenges': {
    en: '{{count}} more challenges',
    ja: '{{count}} more challenges',
    et: '{{count}} more challenges',
    lt: '{{count}} more challenges',
    ph: '{{count}} more challenges',
    ch: '{{count}} more challenges',
  },
  '{{count}} more projects': {
    en: '{{count}} more projects',
    ja: '{{count}} more projects',
    et: '{{count}} more projects',
    lt: '{{count}} more projects',
    ph: '{{count}} more projects',
    ch: '{{count}} more projects',
  },
  'My Wallet': {
    en: 'My Wallet',
    ja: 'My Wallet',
    et: 'My Wallet',
    lt: 'My Wallet',
    ph: 'My Wallet',
    ch: 'My Wallet',
  },
  'This member is just getting started — no challenges completed yet!': {
    en: 'This member is just getting started — no challenges completed yet!',
    ja: 'This member is just getting started — no challenges completed yet!',
    et: 'This member is just getting started — no challenges completed yet!',
    lt: 'This member is just getting started — no challenges completed yet!',
    ph: 'This member is just getting started — no challenges completed yet!',
    ch: 'This member is just getting started — no challenges completed yet!',
  },
  'VIVINAUT Control Panel': {
    en: 'VIVINAUT Control Panel',
    ja: 'VIVINAUT Control Panel',
    et: 'VIVINAUT Control Panel',
    lt: 'VIVINAUT Control Panel',
    ph: 'VIVINAUT Control Panel',
    ch: 'VIVINAUT Control Panel',
  },
  'VIVIBOOM Control Panel': {
    en: 'VIVIBOOM Control Panel',
    ja: 'VIVIBOOM Control Panel',
    et: 'VIVIBOOM Control Panel',
    lt: 'VIVIBOOM Control Panel',
    ph: 'VIVIBOOM Control Panel',
    ch: 'VIVIBOOM Control Panel',
  },
};
